import EventHandler from '@pixelunion/events';
import { transition } from '@pixelunion/animations';

export default class Sidebar {
  constructor(container) {
    if (!container) { return; }

    if (container instanceof HTMLElement) {
      this.container = container;
    } else {
      this.container = container.el.querySelector('[data-sidebar]');
    }

    if (this.container.hasAttribute('data-sidebar')) {
      this.sidebar = this.container;
    } else {
      this.sidebar = this.container.querySelector('[data-sidebar]');
    }

    if (!this.sidebar || this.sidebar.dataset.hasToggle !== 'true') { return; }

    this.toggleLinks = this.sidebar.querySelectorAll('[data-sidebar-toggle]');

    this.events = new EventHandler();

    this.toggleMenu = link => {
      const toggle = link;
      const content = toggle.nextElementSibling;
      const contentTransition = transition({ el: content });

      if (content.dataset.animationState === 'closed') {
        contentTransition.animateTo('open', {
          onStart: ({ el }) => {
            const height = el.scrollHeight;
            el.style.setProperty('--open-height', `${height}px`);
          },
        });
        toggle.dataset.open = 'true';
        toggle.setAttribute('aria-expanded', 'true');
      } else {
        contentTransition.animateTo('closed');
        toggle.dataset.open = 'false';
        toggle.setAttribute('aria-expanded', 'false');
      }
    };

    this.toggleLinks.forEach(link => {
      this.events.register(link, 'click', e => {
        e.preventDefault();
        this.toggleMenu(link);
      });
    });
  }

  unload() {
    if (this.events) {
      this.events.unregisterAll();
    }
  }
}
